export default __webpack_public_path__ + "static/media/arrow-right.8da5ea11.svg";